module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[7]494.2f8a92f.woff2";